var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-stage"},[_c('div',{staticClass:"ornament"}),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._t("headline")],2),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }